<script setup lang="ts">
import BackgroundGradient from '@/components/BackgroundGradient.vue'
defineProps<{
  title: string
  image: string
}>()
</script>

<template>
  <div
    class="w-full cursor-pointer rounded-md border bg-white transition-all duration-300 ease-in-out hover:border-transparent hover:shadow-outline hover:shadow-primary"
  >
    <BackgroundGradient :has-shadow="false" :is-rounded="false">
      <div class="flex items-center justify-center">
        <img :src="image" class="aspect-square w-1/2 object-contain" />
      </div>
    </BackgroundGradient>
    <div class="min-h-[180px] p-5">
      <h1 class="mb-3 text-lg font-semibold">
        {{ title }}
      </h1>
      <p class="text-sm text-muted-foreground">
        <slot />
      </p>
    </div>
  </div>
</template>
